export default {"src":"/_next/static/media/login.79453588.svg","height":610,"width":1172,"blurWidth":0,"blurHeight":0};